// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__SZSXq","image":"styles_image__18UUO","placeholder":"styles_placeholder__1G4bj"};